import { render, staticRenderFns } from "./KamHome.vue?vue&type=template&id=f71f7fb8"
import script from "./KamHome.vue?vue&type=script&lang=js"
export * from "./KamHome.vue?vue&type=script&lang=js"
import style0 from "./KamHome.vue?vue&type=style&index=0&id=f71f7fb8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports